import { render, staticRenderFns } from "./training.vue?vue&type=template&id=61ba67ba&scoped=true&"
import script from "./training.vue?vue&type=script&lang=js&"
export * from "./training.vue?vue&type=script&lang=js&"
import style0 from "./training.vue?vue&type=style&index=0&id=61ba67ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba67ba",
  null
  
)

export default component.exports